
export const convertUtcSecondsToDate = function(utcSeconds) {
    let date = new Date(0);
    date.setUTCSeconds(utcSeconds);
    return date
}

export const convertToIsoString=function(dateString) {
    return new Date(dateString).toISOString();
}

